import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NotePurchaseOrderCreate,
  NotePurchaseOrderCreateVariables,
} from 'common/graphql/__generated__/NotePurchaseOrderCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_PURCHASE_ORDER_CREATE from '../../../../../../graphql/NotePurchaseOrderCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  purchaseOrderId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  purchaseOrderId,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NotePurchaseOrderCreate, // TMutationResult
      NotePurchaseOrderCreateVariables // TMutationVariables
    >
      entityId={purchaseOrderId}
      data={data}
      loading={loading}
      mutationDocument={NOTE_PURCHASE_ORDER_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
